import classNames from 'classnames';
import React from 'react';
import { BookDemoButton } from '../../../../common/buttons/BookDemoButton/BookDemoButton';
import { FacebookPartnerBadge, IconTypeProps, MetaBadge } from '@mm/icons';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { LLR_DEMO_UTM } from '../WebsiteReportSummary/constants';
import styles from './LLRActionButtons.module.css';

export type LLRActionButtonsProps = {
  buttonName?: string;
  className?: string;
  onClick: () => void;
  websiteURL: string;
  withNote?: boolean;
  withFBBadges?: boolean;
  css?: {
    primaryButton?: string;
    demoButton?: string;
  };
  iconProps?: IconTypeProps;
};

export const LLRActionButtons = ({
  buttonName = 'Get Started Free',
  className,
  onClick,
  websiteURL,
  withNote = true,
  withFBBadges,
  css,
  iconProps,
}: LLRActionButtonsProps) => (
  <div className={className}>
    <div className={styles.buttonsWrapper}>
      <div className={styles.buttons}>
        <div className={styles.actionButton}>
          {withFBBadges && (
            <>
              <MetaBadge className={styles.meta} {...iconProps} />
              <FacebookPartnerBadge
                className={styles.facebook}
                width={70}
                height={51}
                {...iconProps}
              />
            </>
          )}
          {buttonName && (
            <PrimaryButton
              onClick={onClick}
              className={classNames(
                styles.button,
                styles.buttonNew,
                css?.primaryButton,
              )}
            >
              {buttonName}
            </PrimaryButton>
          )}
        </div>
        <BookDemoButton
          utm={LLR_DEMO_UTM(websiteURL)}
          className={classNames(styles.button, styles.bookDemoButton)}
          show
        />
      </div>
      {withNote && <div className={styles.text}>No credit card required.</div>}
    </div>
  </div>
);
